import request from '@/lib/api'

const _BASE = "/api";
const BASE_FREE = "/free";

//登录
export function login(data) {
  return request({
    url: `${BASE_FREE}/tPmcAuth/login`,
    method: 'post',
    data
  })
}
//获取当前用户对应的菜单权限列表
export function getUserRole() {
  return request({
    url: `${_BASE}/iam/role/userPermission`,
    method: 'get',
  })
}
//获取用户信息
export function getUserInfo() {
  return request({
    url: `${_BASE}/iam/user/getCurrentUserInfo`,
    method: 'get',
  })
}
//修改用户本身密码
export function changeUserPwd(data) {
  return request({
    url: `${_BASE}/iam/user/changePwd`,
    method: 'post',
    data
  })
}
//验证手机验证码
export function verifyPhone(code) {
  return request({
    url: `${_BASE}/tSocUser/verifySMSCode?phoneCode=${code}`,
    method: 'get',
  })
}
//验证邮箱验证码
export function verifyEmailCode(data) {
  return request({
    url: `${_BASE}/tSocUser/verifyEmailCode`,
    method: 'get',
    params: data
  })
}

//重置密码手机或邮箱验证码
export function resetCaptcha(data) {
  return request({
    url: `${_BASE}/tSocUser/verifyPicCode`,
    method: 'post',
    data
  })
}
//根据手机号重置密码
export function resetPwdPhone(data) {
  return request({
    url: `${_BASE}/tSocUser/resetPwdByPhone`,
    method: 'post',
    data
  })
}
//根据邮箱重置密码
export function resetPwdEmail(data) {
  return request({
    url: `${_BASE}/tSocUser/resetPwdByEmail`,
    method: 'post',
    data
  })
}
// ================用户基本信息===================

//获取用户手机验证码
export function getPhoneCode(data) {
  return request({
    url: `${_BASE}/tSocUser/getSMSCode/${data}`,
    method: 'get',
  })
}
//获取邮箱验证码
export function getEmailCode(data) {
  return request({
    url: `${_BASE}/tSocUser/getEmailCode/${data}`,
    method: 'get',
  })
}
//修改手机号
export function changePhone(data) {
  return request({
    url: `${_BASE}/tSocUser/changePhone`,
    method: 'post',
    data
  })
}

//修改用户信息
export function editUser(id, data) {
  return request({
    url: `${_BASE}/tSocUser/${id}`,
    method: 'put',
    data
  })
}